/** zh-CN catalogue `checker` (W3-09; English: src/features/checker/checker.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'checker',
  locale: 'zh-CN',
  messages: {
    panelTitle: '问题',
    listLabel: '问题',
    severityName: '{severity, select, fatal {致命} error {错误} warning {警告} tip {提示} other {问题}}',
    severityFilter: '{severity, select, fatal {致命} error {错误} warning {警告} tip {提示} other {问题}}（{count}）',
    severityFilterLabel:
      '显示{severity, select, fatal {致命问题} error {错误} warning {警告} tip {提示} other {问题}}（{count}）',
    categoryName: '{category, select, phira {Phira} gameplay {玩法} style {风格} other {其他}}',
    categoryFilterLabel: '显示{category, select, phira {Phira} gameplay {玩法} style {风格} other {其他}}问题',
    filtersLabel: '问题筛选',
    scopeLabel: '显示以下范围的问题',
    scopeChart: '整张谱面',
    scopeLine: '当前判定线',
    scopeLineNone: '请先选择当前判定线',
    searchLabel: '搜索问题',
    searchPlaceholder: '搜索问题…',
    checkNow: '立即检查',
    checking: '正在检查…',
    checkingRest: 'Phira 检查完成；正在检查玩法和风格…',
    checkedStats: '已检查 {lines, plural, other {# 条判定线}}上的 {notes, plural, other {# 个音符}}，用时 {ms} 毫秒',
    notChecked: '尚未检查',
    workerStopped: '谱面检查已停止：在重新打开谱面之前，问题不会更新',
    checkingTitle: '正在检查谱面…',
    checkingBody: '第一次检查完成后，问题会立即显示在这里。',
    shownCount: '{shown} / {total, plural, other {# 个问题}}',
    rowLabel: '{severity}：{message}',
    go: '转到',
    goLabel: '转到此问题',
    goNowhere: '此问题在时间轴上没有位置',
    ignore: '在此忽略',
    ignoreLabel: '在此谱面中忽略此问题（撤销可恢复）',
    moreFixes: '更多修复',
    fixesOf: '修复',
    fixingNote: '已修复。正在重新检查…',
    location: '{line} · {beat}',
    locationChart: '整张谱面',
    tipsShow: '{count, plural, other {显示 # 条提示}}',
    tipsHide: '{count, plural, other {隐藏 # 条提示}}',
    tipsFoldedHint: '建议；没有它们谱面的播放效果也一样',
    failedRules: '有 {count, plural, other {# 项检查}}无法运行（{rules}）：保留了之前的结果。',
    fatalBanner: '有 {count, plural, other {# 个致命问题}}会导致 Phira 无法加载此谱面。在修复之前，快速导出已被阻止。',
    noProjectTitle: '没有打开的谱面',
    noProjectBody: '打开一张谱面以检查其中的 Phira 问题。',
    noProblemsTitle: '未发现问题',
    noProblemsBody: '每次更改后都会重新运行谱面检查。',
    noMatchTitle: '没有符合筛选条件的问题',
    noMatchBody: '其他问题被严重程度、类别、范围或搜索筛选隐藏了。',
    showAll: '显示全部',
    ignoredTitle: '在此谱面中已忽略（{count}）',
    ignoredItem: '{rule} · {title}',
    ignoredUnknown: '{rule}',
    stopIgnoring: '取消忽略',
    stopIgnoringAll: '全部取消忽略',
    cmdShow: '显示问题',
    cmdNext: '下一个问题',
    cmdPrev: '上一个问题',
    cmdQuickFix: '快速修复（应用第一个修复）',
    cmdIgnore: '在此忽略当前问题',
    cmdUnignoreAll: '取消忽略此谱面的所有问题',
    cmdCheckNow: '立即检查谱面',
    reasonNoProject: '请先打开一张谱面',
    reasonNoProblems: '没有问题',
    reasonNoCurrent: '请先转到一个问题（下一个问题）',
    reasonNoIgnored: '此谱面中没有被忽略的问题',
    toastNoProblems: '没有可转到的问题',
    toastNoFix: '此问题没有修复方法',
    toastNoTarget: '请先转到一个问题：“下一个问题”会选中一个',
    toastIgnored: '已在此谱面中忽略',
    toastUnignored: '{count, plural, other {# 个问题}}将重新检查',
    fixNothingChanged: '无需更改：谱面看起来已经正确',
    fixGone: '此问题已消失：发现它之后谱面已改变',
    fixInvalid: '此修复已不适用于谱面',
    fixNoProject: '请先打开一张谱面',
    fixMediaFailed: '无法转换该文件',
    fixMediaRead: '无法从项目存储中读取该文件',
    fixMediaNoDecoder: '此浏览器无法解码音频，因此无法在此转换文件',
    fixMediaDecodeAudio: '浏览器无法解码此音频文件',
    fixMediaNoAudio: '该文件不包含音频',
    fixMediaImage: '无法解码或转换该图片',
    fixMediaGif: '该 GIF 文件已损坏，无法重新设定时间',
    fixMediaStore: '无法保存转换后的文件：项目存储已满或不可用',
    fixUnavailable: '此修复需要项目存储，但它不可用',
    txnFix: '修复问题',
    txnIgnore: '忽略问题 {rule}',
    txnUnignore: '{count, plural, other {取消忽略 # 个问题}}',
    fixSetLineOpacityFull: '修复：显示判定线（不透明度 100%）',
    fixHoldLeadIn: '修复：在第一个关键帧之前保留第一个值',
    fixSetEase: '修复：更改曲线',
    fixSetKeyValue: '修复：更改关键帧的值',
    fixClampKeyValues: '修复：将关键帧的值限制在范围内',
    fixRemoveGifProgress: '修复：移除 GIF 进度',
    fixClampPreviewRange: '修复：将曲目预览移到曲目范围内',
    fixSnapNotesX: '修复：将音符吸附到 X 网格',
    fixDeleteNotes: '修复：删除音符',
    fixMoveNotesLater: '修复：将音符向后移动一个吸附步长',
    fixAlignNoteTimes: '修复：将音符放在同一时间',
    fixSetIncline: '修复：保持恒定的音符倾斜',
    fixResetRpeLineFields: '修复：重置只有 RPE 读取的字段',
    fixAddWhiteColorKey: '修复：添加一个白色的颜色关键帧',
    fixHoldVarLeadIn: '修复：从特效开始时保持特效变量',
    fixRenameAsset: '修复：重命名文件',
    fixRenameHitsoundAsset: '修复：重命名打击音文件',
    fixDeleteEffect: '修复：删除特效',
    fixSetEffectVar: '修复：设置特效变量',
    fixWriteIntegerRpeVersion: '修复：将 RPEVersion 写为整数',
    fixExtendHolds: '修复：将 Hold 延长为一个吸附步长',
    fixConvertNotes: '修复：转换音符',
    fixSetControl: '修复：更改距离控制曲线',
    fixRemoveAssetReferences: '修复：移除文件及其使用处',
    fixConvertAudioToWav: '修复：将音频转换为 WAV',
    fixConvertImageToPng: '修复：将图片转换为 PNG',
    fixReencodeGif: '修复：重新设定 GIF 的帧时间',
    fixDownscaleImage: '修复：缩小图片',
    fixMoveNotesToNewLine: '修复：将音符移出 UI 绑定线',
    fixRemoveIgnoredLineData: '修复：移除 Phira 忽略的判定线数据',
    fixConfirmTiming: '修复：将时间设置标记为已确认',
    fixRemoveAssets: '修复：移除未使用的文件',
    fixDeleteLines: '修复：删除空判定线',
    fixRemoveRedundantKeys: '修复：移除不影响运动的关键帧',
    fixAddTag: '修复：添加标签',
    tickMore: '{message}（另有 {count} 个）',
    setHideTicks: '在时间轴中隐藏问题标记',
    setHideTicksDesc: '问题仍保留在“问题”选项卡中；时间标尺旁和总览条中的标记会消失。',
    setHideTipTicks: '时间轴标记中不包括提示',
    setHideTipTicksDesc: '只有致命问题、错误和警告会在时间标尺旁和总览条中显示标记。',
    setExplainAll: '为列表中的每个问题显示解释',
    setExplainAllDesc:
      '在每一行下方显示该问题在 Phira 中为何重要。否则只有当前所在的问题会显示，其他问题的解释保留在工具提示中。',
    storedMissing: '{song, select, yes {曲目} other {文件}}“{path}”不在此浏览器的存储中。',
    storedMissingWhy:
      '浏览器丢弃了它存储的副本，因此导出的谱面包会缺少它，Phira 无法加载谱面。请再次选择同一个文件以恢复它。',
    fixChooseAgain: '再次选择该文件',
  },
};

export default catalog;
